import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Typography, Button } from '@material-ui/core';
import { getEnderecosDoNegocio, getEnderecosDoUsuario } from '../../store/actions/endereco';
import TituloPagina from '../../components/layout/TituloPagina';

const Enderecos = props => {
    const { origem, idOrigem } = useParams();
    const { enderecos, getEnderecosDoNegocio, getEnderecosDoUsuario } = props;

    useEffect(() => {
        if (origem === 'negocios') getEnderecosDoNegocio(idOrigem);
        else getEnderecosDoUsuario(idOrigem);
    }, [idOrigem]);

    return (
        <>
            <TituloPagina titulo='Endereços Cadastrados' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item xs={12} style={{ paddingTop: '15px', justifyContent: 'space-between' }}>
                {enderecos.length === 0 ? (
                    <Grid container>
                        <Typography variant='body1' component='p'>
                            Nenhum endereço encontrado.
                        </Typography>
                    </Grid>
                ) : (
                    enderecos.map((endereco, index) => (
                        <Grid container xs={6}
                            key={index}
                            style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '15px',
                                backgroundColor: '#f9f9f9',
                            }}
                        >
                            <Grid item xs={12} style={{ paddingBottom: '20px' }}><strong>Nome de Identificação do Endereço:</strong> {endereco.apelidoIdentificacao}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Logradouro:</strong> {endereco.logradouro}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Número:</strong> {endereco.numero}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Complemento:</strong> {endereco.complemento}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Bairro:</strong> {endereco.bairro}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Cidade:</strong> {endereco.cidade}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Estado:</strong> {endereco.estado}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '20px' }}><strong>CEP:</strong> {endereco.cep}</Grid>

                            <Grid item xs={12} style={{ paddingBottom: '10px' }}><strong>Principal:</strong> {endereco.principal ? 'Sim' : 'Não'}</Grid>
                            <Grid item xs={12} style={{ paddingBottom: '20px' }}><strong>Ativo:</strong> {endereco.ativo ? 'Sim' : 'Não'}</Grid>
                            <Button
                                variant='contained'
                                color='secondary'
                                href={`/enderecos/editar-endereco/${origem}/${idOrigem}/${endereco.id}`}
                            >
                                Editar
                            </Button>
                        </Grid>
                    ))
                )}
                <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                    <Button
                        variant='contained'
                        color='primary'
                        href={`/enderecos/cadastrar-endereco/${origem}/${idOrigem}`}
                    >
                        Novo Endereço
                    </Button>
                </Grid>
                <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                    <Button
                        variant='contained'
                        color='secondary'
                        href={`/${origem}/gestao`}
                    >
                        Voltar
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

const mapStateToProps = state => (
    {
        enderecos: state.endereco.enderecos
    }
)

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getEnderecosDoNegocio,
        getEnderecosDoUsuario,
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Enderecos);